import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { InlineSVGModule } from 'ng-inline-svg';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en';

import { AppComponent } from './app.component';
import { ScoreboardComponent } from './common/scoreboard/scoreboard.component';
import { PlayersListComponent } from './map/players-list/players-list.component';
import { MapZonesComponent } from './map/map-zones/map-zones.component';
import { MapRawComponent } from './map/map-raw/map-raw.component';
import { MapControlsComponent } from './map/map-controls/map-controls.component';
import { SelectorComponent } from './common/selector/selector.component';
import { MapComponent } from './map/map/map.component';

// TODO: Delete when Latitude works on Angular 5
import { FormsModule } from '@angular/forms';
import { ToggleComponent } from './latitude/toggle/toggle.component';
import { LegendComponent } from './map/legend/legend.component';

import { MatchTimePipe } from './pipes/match-time.pipe';
import { LocaleService } from './services/locale.service';
import { MatchService } from './services/match.service';
import { CartoService } from './services/carto.service';
import { ContextService } from './services/context.service';
import { StatsService } from './services/stats.service';

import { routing } from './app.routing';
import { MatchComponent } from './match/match.component';
import { PopupZoneComponent } from './map/popup-zone/popup-zone.component';
import { PopupLeaderComponent } from './map/popup-leader/popup-leader.component';
import { StatsComponent } from './stats/stats/stats.component';
import { PlayerBadgeComponent } from './stats/player-badge/player-badge.component';
import { TabSelectComponent } from './common/tab-select/tab-select.component';
import { SummaryTableComponent } from './stats/summary-table/summary-table.component';
import { ShotsSummaryComponent } from './stats/shots-summary/shots-summary.component';
import { MapBaseComponent } from './common/map-base/map-base.component';
import { EventMessageComponent } from './map/event-message/event-message.component';
import { MapGridComponent } from './map/map-grid/map-grid.component';
import { PopupGridComponent } from './map/popup-grid/popup-grid.component';
import { PopupShotComponent } from './map/popup-shot/popup-shot.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { MatchesGuard } from './guards/matches.guard';

export function getCurrentLocaleFactory(localeService: LocaleService) {
  return localeService.locale;
}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

registerLocaleData(localeEs, 'es');
registerLocaleData(localeEn, 'en');

@NgModule({
  declarations: [
    AppComponent,
    ScoreboardComponent,
    PlayersListComponent,
    MapBaseComponent,
    MapComponent,
    MapZonesComponent,
    MapRawComponent,
    MapControlsComponent,
    SelectorComponent,
    LegendComponent,
    ToggleComponent,
    MatchComponent,
    PopupZoneComponent,
    PopupLeaderComponent,
    StatsComponent,
    PlayerBadgeComponent,
    TabSelectComponent,
    SummaryTableComponent,
    ShotsSummaryComponent,
    MatchTimePipe,
    EventMessageComponent,
    MapGridComponent,
    PopupGridComponent,
    PopupShotComponent,
    NotFoundComponent,
  ],
  imports: [
    BrowserModule,
    // TODO: Delete when Latitude works on Angular 5
    FormsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (createTranslateLoader),
          deps: [HttpClient]
      }
    }),
    InlineSVGModule,
    NgxDatatableModule,
    routing
  ],
  providers: [
    MatchesGuard,
    CartoService,
    MatchService,
    ContextService,
    StatsService,
    LocaleService,
    {
      provide: LOCALE_ID,
      deps: [LocaleService],
      useFactory: getCurrentLocaleFactory
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts